
import { AUTH_TOKEN, REFRESH_TOKEN } from './constants';

interface AuthProvider {
  username: null | string;
  isAuthenticated(): boolean;
  signin(token: string, refreshToken: string): Promise<void>;
  signout(): Promise<void>;
}

export const authProvider: AuthProvider = {
  isAuthenticated() {
    const token = localStorage.getItem(AUTH_TOKEN);
    return token != null;
  },
  username: null,
  async signin(token: string, refreshToken: string) {
    localStorage.setItem(AUTH_TOKEN, token);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  },
  async signout() {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
  },
};
